import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export const fetchCount = createAction(`${reduxKey}.FETCH_COUNT`, ()=>({}));
export const fetchCountSuccess = createAction(`${reduxKey}.FETCH_COUNT_SUCCESS`, (count)=>({
        count
    }));
export const fetchCountFailure = createAction(`${reduxKey}.FETCH_COUNT_FAILURE`, ()=>({}));
